module.exports = __webpack_public_path__ + "static/media/code-protection-icon.49790bb4.svg";